// extracted by mini-css-extract-plugin
module.exports = {"noNetwork":"NoNetwork_noNetwork__1e9WF","illustration":"NoNetwork_illustration__2Nx2A","description":"NoNetwork_description__2fbhg","button":"NoNetwork_button__MHpQa"};